import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-singpass-error-modal',
    templateUrl: './singpass-error-modal.component.html',
    styleUrls: ['./singpass-error-modal.component.css']
})
export class SingpassErrorModalComponent {
    @Input() title: string = 'Myinfo is currently unavailable.';
    @Input() body: string = 'To join, cancel and select "Input My info Manually".';
    @Input() buttonStyle = {};
    @Output() close = new EventEmitter<void>();

    onClose() {
        this.close.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/singpass-error-modal/singpass-error-modal.component.ts